import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { VersionSelector as VersionSelectorComponent } from './VersionSelector';

/**
 * The TechDocs custom addons plugin
 * @public
 */
export const techdocsModuleCustomAddonsPlugin = createPlugin({
  id: 'techdocsModuleCustomAddons',
});

/**
 * TechDocs addon that provides a version selector dropdown in the primary sidebar
 *
 * @example
 * ```tsx
 * import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
 * import { VersionSelector } from '@internal/backstage-plugin-techdocs-module-addons';
 *
 * const AppRoutes = () => {
 *   <FlatRoutes>
 *     <Route
 *       path="/docs/:namespace/:kind/:name/*"
 *       element={<TechDocsReaderPage />}
 *     >
 *       <TechDocsAddons>
 *         <VersionSelector />
 *       </TechDocsAddons>
 *     </Route>
 *   </FlatRoutes>;
 * };
 * ```
 *
 * @public
 */
export const VersionSelector = techdocsModuleCustomAddonsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'VersionSelector',
    location: TechDocsAddonLocations.PrimarySidebar,
    component: VersionSelectorComponent,
  }),
);
